<div class="app-multi-select-wrapper">
    <p-multiselect #multiSelectComponent [ngModel]="value()" (ngModelChange)="onValueChange($event)"
        [options]="displayOptions()" [optionLabel]="optionLabel()" [optionValue]="optionValue()"
        [optionDisabled]="optionDisabled() || ''" [placeholder]="getPlaceholderText()"
        [disabled]="multiSelectConfig().disabled || false"
        [filter]="!!(multiSelectConfig().filter && multiSelectConfig().searchable)"
        [showClear]="multiSelectConfig().showClear" [loading]="isLoading()"
        [virtualScroll]="multiSelectConfig().virtualScroll"
        [virtualScrollItemSize]="multiSelectConfig().virtualScrollItemSize" [appendTo]="multiSelectConfig().appendTo"
        [style]="multiSelectConfig().style" [class]="multiSelectConfig().styleClass"
        [panelStyle]="multiSelectConfig().panelStyle" [panelStyleClass]="multiSelectConfig().panelStyleClass"
        [maxSelectedLabels]="multiSelectConfig().maxSelectedLabels"
        [selectedItemsLabel]="multiSelectConfig().selectedItemsLabel || '{0} items selected'"
        [display]="multiSelectConfig().display || 'comma'" [showToggleAll]="multiSelectConfig().showToggleAll"
        [selectionLimit]="multiSelectConfig().selectionLimit" [group]="multiSelectConfig().group"
        [optionGroupLabel]="multiSelectConfig().optionGroupLabel || 'label'"
        [optionGroupChildren]="multiSelectConfig().optionGroupChildren || 'items'"
        [overlayOptions]="multiSelectConfig().overlayOptions" (onFilter)="onSearchInput($event)" (onShow)="handleShow()"
        (onHide)="handleHide()" (onClear)="handleClear()" (onFocus)="handleFocus()" (onBlur)="handleBlur()"
        (onSelectAllChange)="handleSelectAllChange($event)" [selectAll]="selectAll()">
        <!-- Custom item template -->
        <ng-template pTemplate="item" let-option>
            <ng-container *ngIf="itemTemplate(); else defaultItem">
                <ng-container *ngTemplateOutlet="itemTemplate()!; context: { $implicit: option }"></ng-container>
            </ng-container>
            <ng-template #defaultItem>
                <div class="flex items-center gap-2 py-1" [class.opacity-50]="option.disabled">
                    <img *ngIf="option.icon && !option.icon.startsWith('pi-')" [src]="option.icon"
                        [alt]="option[optionLabel()]" class="w-5 h-5" />
                    <i *ngIf="option.icon && option.icon.startsWith('pi-')" [class]="'pi ' + option.icon"></i>
                    <span class="text-sm">{{ option[optionLabel()] }}</span>
                </div>
            </ng-template>
        </ng-template>

        <!-- Custom selected items template -->
        <ng-template pTemplate="selecteditems" let-selectedOptions *ngIf="selectedItemsTemplate()">
            <ng-container
                *ngTemplateOutlet="selectedItemsTemplate()!; context: { $implicit: selectedOptions }"></ng-container>
        </ng-template>

        <!-- Custom chip template -->
        <ng-template pTemplate="chip" let-option *ngIf="chipTemplate()">
            <ng-container *ngTemplateOutlet="chipTemplate()!; context: { $implicit: option }"></ng-container>
        </ng-template>

        <!-- Custom group template -->
        <ng-template pTemplate="group" let-group *ngIf="groupTemplate()">
            <ng-container *ngTemplateOutlet="groupTemplate()!; context: { $implicit: group }"></ng-container>
        </ng-template>

        <!-- Custom header template -->
        <ng-template pTemplate="header" *ngIf="headerTemplate()">
            <ng-container *ngTemplateOutlet="headerTemplate()!"></ng-container>
        </ng-template>

        <!-- Custom header checkbox icon template -->
        <ng-template pTemplate="headercheckboxicon" let-allSelected let-partialSelected="partialSelected"
            *ngIf="headerCheckboxIconTemplate()">
            <ng-container *ngTemplateOutlet="headerCheckboxIconTemplate()!; context: { 
                $implicit: allSelected, 
                partialSelected: partialSelected 
            }"></ng-container>
        </ng-template>

        <!-- Custom footer template for load more or infinite scroll -->
        <ng-template pTemplate="footer">
            <ng-container *ngIf="footerTemplate(); else defaultFooter">
                <ng-container *ngTemplateOutlet="footerTemplate()!"></ng-container>
            </ng-container>
            <ng-template #defaultFooter>
                <div *ngIf="multiSelectConfig().infiniteScroll && hasMore() && !isLoading()" class="p-2 text-center">
                    <app-button [label]="'Load More'" variant="outlined" severity="secondary"
                        [icon]="'pi pi-arrow-down'" (clicked)="loadMore()" />
                </div>
                <div *ngIf="isLoading()" class="p-2 text-center">
                    <i class="pi pi-spinner pi-spin text-blue-600"></i>
                    <span class="ml-2 text-sm text-gray-600">Loading...</span>
                </div>
            </ng-template>
        </ng-template>

        <!-- Custom empty template -->
        <ng-template pTemplate="empty">
            <ng-container *ngIf="emptyTemplate(); else defaultEmpty">
                <ng-container *ngTemplateOutlet="emptyTemplate()!"></ng-container>
            </ng-container>
            <ng-template #defaultEmpty>
                <div class="p-4 text-center text-gray-500">
                    <i class="pi pi-info-circle text-2xl mb-2"></i>
                    <p class="text-sm">
                        {{ searchQuery() ? 'No results found' : 'No options available' }}
                    </p>
                </div>
            </ng-template>
        </ng-template>
    </p-multiselect>
</div>
